import { MainSpacePage } from '../../components/service';
export const SpacePageView = () => {
  return <MainSpacePage data-sentry-element="MainSpacePage" data-sentry-component="SpacePageView" data-sentry-source-file="spaces.tsx" />;
};